import FooterI18n from './Footer.i18n.js';

export default {

  components: {},

  props: {},

  computed: {},

  data() {
    return {};
  },

  watch: {},

  methods: {},

  mounted() {},

  i18n: FooterI18n,

};
